/*
 * @Author: fusiyuan 1152054863@qq.com
 * @Date: 2025-08-04 11:52:52
 * @LastEditors: fusiyuan 1152054863@qq.com
 * @LastEditTime: 2025-09-09 16:03:23
 * @FilePath: \slbq-web\management-side\src\api\home.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const homeGet = "/sys/order/current"; //最近成交单
export const shoppingGet = "/sys/statistics"; //商城销售数据
export const commodityGet = "/sys/statistics/spu-check-pending"; //商品待审核
export const shopGet = "/sys/statistics/store-check-pending"; //店铺待审核
export const storeGet = "/sys/store/count-by-type"; //店铺类型统计
export const userGet = "/sys/statistics/user-type"; //用户类型统计
export const feedbackGet = "/sys/statistics/store-complaint"; //投诉店铺待处理
export const complainGoodsGet = "/sys/statistics/spu-complaint"; //投诉商品待处理
export const complainStoreGet = "/sys/statistics/feedback"; //意见反馈待处理
export const commodityClassifyGet = "/sys/spu/analysis"; //商品分类比例
export const topShop = "/sys/statistics/top"; //商城店铺销售排行
export const withdrawing = "/admin/withdrawal/waitCheck"; //提现待审核
// export const withdrawing = "/sys/statistics/withdrawal-check-pending";//提现待审核
// export const worksChecking = "/sys/statistics/work-check-pending";//作品待审核
export const worksChecking = "/works/worksUpload/workWaitCheck"; //作品待审核
export const topPtbq = "/copyright/normalregistration/getPending"; //普通版权待处理
export const topFpdcl = "/payInvoice/getPending"; //发票待处理
export const topBqwqdcl = "/protectright/getPending"; //版权维权待处理
export const bqdjMap = "/copyright/normalregistration/sevenDaysStatistic"; //版权登记图标
export const bqbhMap = "/protectright/sevenDaysStatistic"; //版权保护图标
export const registerSourceGet = "/sys/statistics/register-source-sts"; //登记来源
export const workCategoryGet = "/sys/statistics/work-category-sts"; //版权登记作品分类
